import styles from './ServiceMainTitle.module.scss'
import Breadcrumb from 'components/commons/Breadcrumb/Breadcrumb'
import { useEffect, useRef } from 'react'
import { gsap, Power4 } from 'gsap'
import Button from 'components/commons/Button/Button'

interface Props {
  serviceMainTitle: {
    category: string
    title: string
    sub_title: string
    sub_title2: string
    text: string
    text2?: string
    imgSrc: string
  }
  paths: {
    name: string
    url: string
  }[]
  addButton?: boolean
}

const ServiceMainTitle: React.FC<Props> = ({ serviceMainTitle, paths = false, addButton = false }) => {
  const wrapper = useRef<HTMLDivElement>(null)
  const category = useRef<HTMLHeadingElement>(null)
  const title = useRef<HTMLHeadingElement>(null)
  const text = useRef<HTMLDivElement>(null)
  const img = useRef<HTMLImageElement>(null)

  useEffect(() => {
    if (wrapper.current) {
      gsap.fromTo(wrapper.current, { opacity: 0 }, {
        opacity: 1,
        duration: 1,
        ease: Power4.easeOut,
      });

      const tweenVars = {
        y: 50,
        opacity: 0,
        ease: Power4.easeOut,
        duration: 1,
      };

      gsap.timeline()
      .add(gsap.from(category.current, tweenVars), 0.2)
      .add(gsap.from(title.current, tweenVars), 0.4)
      .add(gsap.from(text.current, tweenVars), 0.6)
      .add(gsap.from(img.current, tweenVars), 0.8);
    }
  }, []);

  return (
    <section className={styles.mainTitle} ref={wrapper}>
      <div className={styles.wrapper}>
        <div className={styles.leftContents}>
          <div className={styles.breadcrumbs}>
            <Breadcrumb paths={paths} />
          </div>
          <div className={styles.headding}>
            <div className={styles.headding_ttl}>
              <h1 className={styles.headding_ttl_main}>
                <span ref={category}>{serviceMainTitle.category}</span>
                <span ref={title}>{serviceMainTitle.title}</span>
              </h1>
              <p className={styles.headding_ttl_desc} ref={text}>
                {serviceMainTitle.text}
                {serviceMainTitle.text2 && (
                  <>
                    <br />
                    {serviceMainTitle.text2}
                  </>
                )}
              </p>
            </div>
            {addButton ? (
              <div style={{ maxWidth: '180px', marginBottom: '20px' }}>
                <Button text="特設サイトはこちら" href="https://gomobile.jp/flamingo/" isExternal />
              </div>
            ) : (
              ''
            )}
          </div>
        </div>
        {serviceMainTitle.imgSrc && (
          <figure className={styles.topbg}>
            <img src={serviceMainTitle.imgSrc} alt={serviceMainTitle.title} ref={img} />
          </figure>
        )}
      </div>
    </section>
  )
}
export default ServiceMainTitle
